import axiosInstance from './axiosInstance';

export const fetchPublication = async (status, token) => {
  try {
    const response = await axiosInstance.get(`publicationsandpublicationstypeandattributedata/publicationsElasticJSONFullList/${status}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching publication list:", error);
    throw error;
  }
};


export const getListByAuthorid = async (id, status, token) => {
  try {
    const response = await axiosInstance.get(`publications/ListByAuthorId/${id}/${status}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Publishers list:", error);
    throw error;
  }
};

export const ListByPublisherId = async (id, status, page, size, token) => {
  try {
    const response = await axiosInstance.get(`publications/ListByPublisherId/${id}/${status}`, {
      params: { page, size },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Publishers list:", error);
    throw error;
  }
};

export const ListByPublisherIdsearch = async (id, status, page, size, token) => {
  try {
    const response = await axiosInstance.get(`publications/search/ListByPublisherId/${id}/${status}`, {
      params: { page, size },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Publishers list:", error);
    throw error;
  }
};

export const publicationListByStatus = async (status, token, page, size) => {
  try {
    const response = await axiosInstance.get(`publications/ListByStatus/${status}`, {
      params: { page, size },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching publication list:", error);
    throw error;
  }
};

export const publicationSuggestion = async (token, params) => {
  try {
    const response = await axiosInstance.post(`publicationSearch/publicationSuggestion`, params, {

      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching publication suggestions:", error);
    throw error;
  }
};


export const publicationdetail = async (id, token) => {
  try {
    const response = await axiosInstance.get(`publications/search/publicationdetail/${id}/-1`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching publicationdetail:", error);
    throw error;
  }
};

export const publicationdetailDTO = async (id, token) => {
  try {
    const response = await axiosInstance.get(`publications/search/publicationdetailDTO/${id}/-1`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching publicationdetail:", error);
    throw error;
  }
};

export const publicationsearchdetailDTO = async (id, token) => {
  try {
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    const response = await axiosInstance.get(
      `publications/searchDetail/publicationdetailDTO/${id}/-1`,
      { headers }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching publicationdetail:", error);
    throw error;
  }
};


export const PDFFileSave = async (publicationid, statusnot, data, token) => {
  try {
    const response = await axiosInstance.post(`publications/PDFFileSave/${publicationid}/${statusnot}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};




export const updateStatusPublication = async (id, status, token) => {
  const response = await axiosInstance.get(`publications/updateStatus/${id}/${status}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const getPublicationTypeList = async () => {
  try {
    const response = await axiosInstance.get('publicationSearch/getTypeList');
      return response.data; 
  } catch (error) {
    console.error('Error pbtypegetlist:', error);
    throw error;
  }

};

export const publicationsForDatabaseFind = async (page, size, searchParams, token) => {
  try {
    const response = await axiosInstance.post(
      `publications/PublicationsForDatabaseFind`,
      {
        searchkeyword: searchParams.searchkeyword,
        identifier: searchParams.identifier,
        publicationtype: searchParams.publicationtype,
        status: 1,
      },
      {
        params: {
          page,
          size,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error searching for publications:', error);
    throw error;
  }
};


export const publicationIdAndPublicationTypeByBookMarkListStatusNot = async (id, publicationtype, token, page = 1, size = 10000) => {
  try {
    const response = await axiosInstance.get(
      `publicationSearch/publicationIdAndPublicationTypeByBookMarkListStatusNot/${id}/${publicationtype}/-1?page=${page}&newpagesize=${size}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching publication detail:", error);
    throw error;
  }
};

export const pdfViewerPublicationIdAndPublicationTypeByBookMarkListStatusNot = async (id, publicationtype, token, page = 1, size = 10000, status = 2) => {
  try {
    const response = await axiosInstance.get(
      `publicationSearch/search/publicationIdAndPublicationTypeByBookMarkListStatusNot/${id}/${publicationtype}/${status}?page=${page}&newpagesize=${size}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching publication detail:", error);
    throw error;
  }
};


export const pdfViewerPublicationIdAndPublicationTypeByBookMarkListStatus = async (id, publicationtype, token, page = 1, size = 10000) => {
  try {
    const response = await axiosInstance.get(
      `publicationSearch/search/publicationIdAndPublicationTypeByBookMarkListStatus/${id}/${publicationtype}/1?page=${page}&newpagesize=${size}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching publication detail:", error);
    throw error;
  }
};


//statusu 2 olanlar için
export const pdfViewerPublicationIdAndPublicationTypeByBookMarkListStatusTwo = async (id, publicationtype, token, page = 1, size = 10000) => {
  try {
    const response = await axiosInstance.get(
      `publicationSearch/search/publicationIdAndPublicationTypeByBookMarkListStatus/${id}/${publicationtype}/2?page=${page}&newpagesize=${size}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching publication detail:", error);
    throw error;
  }
};


export const publicationBookMarkList = async (id, token) => {
  try {
    const response = await axiosInstance.get(`publications/search/publicationBookMarkList/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching publication detail:", error);
    throw error;
  }
};


export const pdfViewerPublicationIdAndPublicationTypeByBookMarkListStatusNotMinusOne = async (id, publicationtype, token, page = 1, size = 10000) => {
  try {
    const response = await axiosInstance.get(
      `publicationSearch/search/publicationIdAndPublicationTypeByBookMarkListStatusNot/${id}/${publicationtype}/-1?page=${page}&newpagesize=${size}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching publication detail:", error);
    throw error;
  }
};
